import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e321062"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_2 = { class: "badge" }
const _hoisted_3 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_4 = {
  key: 1,
  class: "badge"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { IHeadersTable } from '@/types';
import { withDefaults } from 'vue';
import {
  AtomInput,
  AtomCheckBox,

} from '../atoms';

interface IProps {
  headers: Array<IHeadersTable>;
  items: any[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTableSmallModal2',
  props: {
    headers: {},
    items: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col),
    _createVNode(_component_v_table, { class: "border-table" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (item, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: "text-dark border-r",
                key: String(index)
              }, [
                _createElementVNode("strong", null, _toDisplayString(item.label), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (head, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: String(index)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass(["border-r", { 'justify-center align-center plus': head.field == 'period', }]),
                    key: String(index)
                  }, [
                    (head.extra)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(head.extra.composite, (c, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: String(index),
                              class: "me-2"
                            }, [
                              _createElementVNode("span", _hoisted_2, _toDisplayString(item[c]), 1),
                              (index < head.extra.composite.length-1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(head.extra.join), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (!head.type)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item[head.field]), 1))
                        : (head.type === 'checkbox')
                          ? (_openBlock(), _createBlock(_unref(AtomCheckBox), {
                              key: 2,
                              modelValue: item[head.field],
                              "onUpdate:modelValue": ($event: any) => ((item[head.field]) = $event),
                              disabled: true,
                              checked: item[head.field]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "checked"]))
                          : _createCommentVNode("", true),
                    (head.type === 'text')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (item[head.field])
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                _createVNode(_unref(AtomInput), {
                                  class: "p-2",
                                  modelValue: item[head.field],
                                  "onUpdate:modelValue": ($event: any) => ((item[head.field]) = $event),
                                  placeholder: "..%",
                                  disabled: true
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_7, "Não se aplica"))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ], 64))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})